/**
 * Date-extensions locale Montenegrin [me]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('me', {
    monthNames: ['Januar','Februar','Mart','April','Maj','Jun','Jul','Avgust','Septembar','Oktobar','Novembar','Decembar'],
    monthShortNames: ['Jan.','Feb.','Mar.','Apr.','Maj','Jun','Jul','Avg.','Sep.','Okt.','Nov.','Dec.'],
    dayNames: ['Nedjelja','Ponedjeljak','Utorak','Srijeda','četvrtak','Petak','Subota'],
    dayShortNames: ['Ned.','Pon.','Uto.','Sri.','čet.','Pet.','Sub.']
});
